import Popper from '@mui/material/Popper';

function ZPopper(props) {
    const { style, ...rest } = props;
    return <Popper {...rest} style={{ ...style, zIndex: 10000000001 }} />;
}

export default ZPopper;
